import styles from './summary.module.scss';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getFirstAndLastRSF } from 'services/inSite/inSite';
import { lastElement } from 'utils/arrays';
import { addThousandSeparator, addPlusMinus5PercentageRangeToNumber } from 'utils/numbers';
import { getFormatSeparatorsOptions } from 'config/marketConfig';

export default function Summary(props) {
  const na = useSelector((state) => state.na);
  const { t } = useTranslation();
  const MODE_ALL_SPACE_TYPES = !props.office_type_id;
  const office_type_id = props.office_type_id;

  const formatOptions = getFormatSeparatorsOptions();
  const space_types_rsf = getFirstAndLastRSF(na.spaces, formatOptions);
  const totalSeats = lastElement(na.growth.map((growth_row) => growth_row.seats));

  let space_types_text;
  let rsf_text;
  let rsf_per_employee_text;

  const space = na.spaces.find((naSpace) => naSpace.id === office_type_id);
  if (MODE_ALL_SPACE_TYPES) {
    rsf_text = `${space_types_rsf.last} ${t('summary.to')} ${space_types_rsf.first}`;
  } else {
    space_types_text = t(space.name);
    rsf_text = addPlusMinus5PercentageRangeToNumber(space.rentableSquareFeet, formatOptions);
    rsf_per_employee_text = space.rentableSquareFeetPerHead;
  }

  return (
    <div className={styles.column2}>
      <div className={styles.content}>
        <div className={styles.title}>{t('summary.title')}</div>
        {!MODE_ALL_SPACE_TYPES && <div className={styles.space_styles}>{space_types_text}</div>}
        <div className={styles.box}>
          <div className={styles.box_numbers}>{rsf_text}</div>
          <div className={styles.box_text}>{t('summary.total')}</div>
        </div>
        <div className={styles.box} hidden={MODE_ALL_SPACE_TYPES}>
          <div className={styles.box_numbers}>
            {addThousandSeparator(totalSeats, formatOptions)}
          </div>
          <div className={styles.box_text}>{t('summary.inOfficeAndHybrid')}</div>
        </div>
        <div className={styles.box} hidden={MODE_ALL_SPACE_TYPES}>
          <div className={styles.box_numbers}>
            {addThousandSeparator(rsf_per_employee_text, formatOptions)}
          </div>
          <div className={styles.box_text}>{t('summary.rentableArea')}</div>
        </div>
      </div>
    </div>
  );
}
